<script>
import filter from 'lodash/filter';
import findIndex from 'lodash/findIndex';
import vueMixins from 'viralstyle-ui/src/vueMixins';
import { mapState, mapGetters } from 'vuex';

import BuyerCheckbox from './BuyerCheckbox';

export default {
  components: {
    BuyerCheckbox,
  },
  mixins: [vueMixins],
  props: {
    selectedCategory: Object,
    categories: Object,
  },
  data: () => ({
    showAll: false,
    categoryType: 'parent',
  }),
  computed: {
    selectedCategories() {
      if (!this.selectedCategory) {
        this.categoryType = 'parent';

        return this.categories.parent;
      }

      let categories = filter(this.categories.sub, category => category.parent_id === this.selectedCategory.id);

      if (!categories.length) {
        // VSMAIN-10604
        // // if the category displayed is already sub-sub then lets just keep it that way
        // if (this.categoryType === 'sub-sub') {
        //   // handles when a sub sub category is selected
        //   categories = filter(this.categories['sub-sub'], category => category.parent_id === this.selectedCategory.parent_id);
        // 
        //   // handles when the sub sub category is cleared
        //   if (!categories.length) {
        //     categories = filter(this.categories['sub-sub'], category => category.parent_id === this.selectedCategory.id);
        //   }
        // } else {
        //   // handles when sub category is selected
        //   categories = filter(this.categories['sub-sub'], category => category.parent_id === this.selectedCategory.id);
        //
        //   // handles when sub sub category is selected via route
        //   if (!categories.length) {
        //     categories = filter(this.categories['sub-sub'], category => category.parent_id === this.selectedCategory.parent_id);
        //   }
        //
        //   this.categoryType = 'sub-sub';
        // }


        // if there are no sub-sub categories then lets just show the sub category as the max nest
        if (!categories.length) {
          categories = filter(this.categories.sub, category => category.parent_id === this.selectedCategory.parent_id);

          this.categoryType = 'sub';
        }

        // if there are no sub categories then show the parent categories
        if (!categories.length) {
          categories = filter(this.categories.parent, category => category.parent_id === this.selectedCategory.parent_id);

          this.categoryType = 'parent';
        }
      } else {
        this.categoryType = 'sub';
      }

      return categories;
    },
    selectedCategoryIndex() {
      let index = findIndex(this.selectedCategories, categoryObj => categoryObj === this.selectedCategory);

      return index + 1 > 5 ? index + 1 : 5;
    },
    visibleCategories() {
      if (this.selectedCategories.length - this.selectedCategoryIndex === 0) {
        this.showAll = true;
      }

      return this.showAll ? this.selectedCategories : this.selectedCategories.slice(0, this.selectedCategoryIndex);
    },
  },
  methods: {
    handleSelectCategory(categoryObj) {
      if (this.selectedCategory !== categoryObj) {
        this.$emit('update-state', { property: 'selectedCategory', value: categoryObj });

        this.$emit('get-campaigns');
      }
    },
  },
};
</script>

<template lang='pug'>
.pt-2.pb-1
  .font-bold.tracking-widest.text-lg.md_text-sm TREND
  buyer-checkbox.text-brand-secondary-850.cursor-pointer.hover_underline.mt-_75(
    v-for='categoryObj in visibleCategories',
    :small='$mq === "sm" || $mq === "md" ? false : true',
    :key='categoryObj.id',
    :label='categoryObj.category',
    :model='categoryObj === selectedCategory',
    :value='true',
    @input='handleSelectCategory(categoryObj)'
  )
  .text-sm.text-brand-secondary-400.mt-1.ml-1_75.cursor-pointer.hover_underline.inline-block(
    v-show='selectedCategories.length - selectedCategoryIndex > 0',
    tabindex='0',
    @click='showAll = !showAll',
    @keyup.enter='showAll = !showAll',
  )
    span(v-if='showAll') Less
    span(v-else) +{{selectedCategories.length - selectedCategoryIndex}} More
</template>